import { createIcon } from "@chakra-ui/icons";

export const ImportSchematisationIcon = createIcon({
  displayName: "ImportSchematisation",
  viewBox: "0 0 19 19",
  path: (
    <g>
      <path
        d="M1.85547 13.333C2.07444 14.097 2.74186 14.6706 3.55566 14.749V16H2C0.895431 16 0 15.1046 0 14V13.333H1.85547ZM7 15C7 15.3646 7.09906 15.7056 7.26953 16H4.44434V14.6289C5.02048 14.4102 5.46634 13.9308 5.6377 13.333H7V15ZM1.90723 3.55566C2.16748 4.2413 2.79792 4.7434 3.55566 4.81641V10.8301C2.67301 10.9151 1.96216 11.5832 1.80957 12.4443H0V3.55566H1.90723ZM9.90723 3.55566C10.1675 4.2413 10.7979 4.7434 11.5557 4.81641V7H9C7.89543 7 7 7.89543 7 9V12.4443H5.68359C5.56158 11.7559 5.08288 11.1925 4.44434 10.9502V4.69629C4.96969 4.49683 5.38649 4.08103 5.58594 3.55566H9.90723ZM16 7H12.4443V4.69629C12.9697 4.49683 13.3865 4.08103 13.5859 3.55566H16V7ZM3.55566 0.898438C2.62074 0.988482 1.87703 1.73203 1.78711 2.66699H0V2C0 0.895431 0.895431 0 2 0H3.55566V0.898438ZM11.5557 0.898438C10.6207 0.988482 9.87703 1.73203 9.78711 2.66699H5.70605C5.63315 1.90906 5.13013 1.27881 4.44434 1.01855V0H11.5557V0.898438ZM14 0C15.1046 0 16 0.895431 16 2V2.66699H13.7061C13.6331 1.90906 13.1301 1.27881 12.4443 1.01855V0H14Z"
        fill="currentColor"
        opacity="0.35"
      />
      <line
        x1="3.99999"
        y1="1.94273e-08"
        x2="3.99999"
        y2="16"
        stroke="currentColor"
        strokeWidth="0.888889"
      />
      <path d="M12 0L12 7" stroke="currentColor" strokeWidth="0.888889" />
      <line y1="12.8856" x2="7" y2="12.8856" stroke="currentColor" strokeWidth="0.888889" />
      <line y1="3.11122" x2="16" y2="3.11122" stroke="currentColor" strokeWidth="0.888889" />
      <circle cx="3.74672" cy="2.8578" r="1.96889" fill="currentColor" />
      <circle cx="11.7467" cy="2.8578" r="1.96889" fill="currentColor" />
      <circle cx="3.74672" cy="12.7899" r="1.96889" fill="currentColor" />
      <path
        d="M13.5 11.4047V15.5952M11.4048 13.4999H15.5952M9.83332 8.78564H17.1667C17.7452 8.78564 18.2143 9.25468 18.2143 9.83326V17.1666C18.2143 17.7452 17.7452 18.2142 17.1667 18.2142H9.83332C9.25474 18.2142 8.78571 17.7452 8.78571 17.1666V9.83326C8.78571 9.25468 9.25474 8.78564 9.83332 8.78564Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  ),
});
